export default "__VITE_ASSET__eaf37891__"